import { observer } from '../animations/animate';
import { GalleryPage } from '../helpers/enums';

/* Dynamically create a responsive image using multiple srcsets */
export const generatePicture = (image: HTMLElement, page: GalleryPage) => {
  /* Create new <picture> */
  const newElementPicture = document.createElement('picture');

  const isPortrait = image.getAttribute('js-gallery-portrait');
  const canRenderPortrait = page === GalleryPage.CAROUSEL && isPortrait == 'true';

  /* Create desktop srcset, if exists */
  if (image.hasAttribute('srcDesktop')) {
    const portrait = canRenderPortrait && image.hasAttribute('srcDesktopPortrait');
    const newElementSrcDesktop = document.createElement('source');
    newElementSrcDesktop.setAttribute('media', '(min-width: 64em)');
    newElementSrcDesktop.setAttribute(
      'srcset',
      portrait ? image.getAttribute('srcDesktopPortrait')! : image.getAttribute('srcDesktop')!
    );
    newElementPicture.append(newElementSrcDesktop);
  }

  /* Create tablet srcset, if exists */
  if (image.hasAttribute('srcTablet')) {
    const portrait = canRenderPortrait && image.hasAttribute('srcTabletPortrait');
    const newElementSrcTablet = document.createElement('source');
    newElementSrcTablet.setAttribute('media', '(min-width: 48em)');
    newElementSrcTablet.setAttribute(
      'srcset',
      portrait ? image.getAttribute('srcTabletPortrait')! : image.getAttribute('srcTablet')!
    );

    newElementPicture.append(newElementSrcTablet);
  }

  /* Create mobile srcset, if exists */
  if (image.hasAttribute('srcMobile')) {
    const portrait = canRenderPortrait && image.hasAttribute('srcMobilePortrait');
    const newElementSrcMobile = document.createElement('source');
    newElementSrcMobile.setAttribute('media', '(min-width: 0)');
    newElementSrcMobile.setAttribute(
      'srcset',
      portrait ? image.getAttribute('srcMobilePortrait')! : image.getAttribute('srcMobile')!
    );
    newElementPicture.append(newElementSrcMobile);
  }

  /* Create new <img> */
  const newElementImg = document.createElement('img');
  newElementImg.classList.add('img-cover');
  if (page === GalleryPage.CAROUSEL) {
    newElementImg.classList.add('object-fit--contain');
  }

  const urlAttribute = image.getAttribute('srcMobile') ?? '';
  const urlToUse = urlAttribute?.includes('1x') ? urlAttribute?.split('1x')[0].trim() : urlAttribute;

  newElementImg.setAttribute('src', urlToUse);
  newElementImg.setAttribute('alt', image.getAttribute('alt')!);
  newElementImg.setAttribute('loading', 'lazy');
  newElementPicture.append(newElementImg);

  if (page === GalleryPage.GRID) {
    /* Apply animation effect to new images */
    newElementPicture.setAttribute('js-animate', 'fade-in');
    observer.observe(newElementPicture);
  }

  return newElementPicture;
};
